@let active = node().isSelected || isNoneSelected();

@if (!node().count && node().details?.['name']) {
  <!-- for not clickable nodes and have hover effect like (related projects) -->
  <div
    class="border p-md rounded-lg flex items-center gap-md w-[19.875rem] relative h-7xl z-[2] text-start [&.has-children]:after:content-[''] [&.has-children]:after:absolute [&.has-children]:after:top-1/2 [&.has-children]:after:start-[calc(100%+0.5rem)] [&.has-children]:after:w-[calc(2rem+1px)] [&.has-children]:after:h-px [&.has-children]:after:bg-neutral-200 [&.has-children]:after:-translate-y-1/2 [&.has-children]:after:z-[1] [&.has-children.active]:after:bg-primary-500 [&.is-child]:before:content-[''] [&.is-child]:before:absolute [&.is-child]:before:top-1/2 [&.is-child]:before:end-[calc(100%+0.5rem)] [&.is-child]:before:w-[calc(2rem+1px)] [&.is-child]:before:h-px [&.is-child]:before:bg-neutral-200 [&.is-child]:before:-translate-y-1/2 [&.is-child]:before:z-[1] [&.is-child.active]:before:bg-primary-500"
    [class.has-children]="node().count && node().isSelected"
    [class.border-neutral-200]="!node().isSelected"
    [class.border-primary-500]="node().isSelected || node().isHighlighted"
    [class.active]="active"
    [class.is-child]="node().isChild"
    [class.me-5xl]="node().count && active"
    [class.bg-neutral-50]="node().isHighlighted"
    [class.ms-5xl]="node().isChild"
    libTooltip
    [toolTipTemplate]="node().detailsTemplate ?? null"
    [toolTipTemplateContext]="{ $implicit: node() }"
    placement="bottom"
    [hasCloseIcon]="false"
    toolTipAction="mouseenter"
    [position]="'absolute'"
    [toolTipClass]="
      'border border-primary-200 bg-primary-50 shadow-xs p-md rounded-lg ' +
      (node().isChild
        ? 'w-[19.875rem] !top-[calc(4rem+0.125rem)] !start-[calc(2.5rem-0.0625rem)]'
        : 'w-[19.875rem] !top-[calc(4rem+0.125rem)] !start-0')
    ">
    <ng-container [ngTemplateOutlet]="cardTemplate" />
  </div>
} @else if (node().details?.['name']) {
  <!-- for clickable nodes and have hover effect like (employees) -->
  <button
    type="button"
    class="border p-md rounded-lg flex items-center gap-md w-[19.875rem] relative h-7xl z-[2] text-start [&.has-children]:after:content-[''] [&.has-children]:after:absolute [&.has-children]:after:top-1/2 [&.has-children]:after:start-[calc(100%+0.5rem)] [&.has-children]:after:w-[calc(2rem+1px)] [&.has-children]:after:h-px [&.has-children]:after:bg-neutral-200 [&.has-children]:after:-translate-y-1/2 [&.has-children]:after:z-[1] [&.has-children.active]:after:bg-primary-500 [&.is-child]:before:content-[''] [&.is-child]:before:absolute [&.is-child]:before:top-1/2 [&.is-child]:before:end-[calc(100%+0.5rem)] [&.is-child]:before:w-[calc(2rem+1px)] [&.is-child]:before:h-px [&.is-child]:before:bg-neutral-200 [&.is-child]:before:-translate-y-1/2 [&.is-child]:before:z-[1] [&.is-child.active]:before:bg-primary-500"
    [class.has-children]="node().count && node().isSelected"
    [class.border-neutral-200]="!node().isSelected"
    [class.border-primary-500]="node().isSelected || node().isHighlighted"
    [class.active]="active"
    [class.is-child]="node().isChild"
    [class.me-5xl]="node().count && active"
    [class.bg-neutral-50]="node().isHighlighted"
    [class.ms-5xl]="node().isChild"
    libTooltip
    [toolTipTemplate]="node().detailsTemplate ?? null"
    [toolTipTemplateContext]="{ $implicit: node() }"
    placement="bottom"
    [hasCloseIcon]="false"
    toolTipAction="mouseenter"
    [position]="'absolute'"
    [toolTipClass]="
      'border border-primary-200 bg-primary-50 shadow-xs p-md rounded-lg ' +
      (node().isChild
        ? 'w-[19.875rem] !top-[calc(4rem+0.125rem)] !start-[calc(2.5rem-0.0625rem)]'
        : 'w-[19.875rem] !top-[calc(4rem+0.125rem)] !start-0')
    "
    (click)="onCardClick()">
    <ng-container [ngTemplateOutlet]="cardTemplate" />
  </button>
} @else {
  <!-- for clickable nodes and don't have hover effect like (departments) -->
  <button
    type="button"
    class="border p-md rounded-lg flex items-center gap-md w-[19.875rem] relative h-7xl z-[2] text-start [&.has-children]:after:content-[''] [&.has-children]:after:absolute [&.has-children]:after:top-1/2 [&.has-children]:after:start-[calc(100%+0.5rem)] [&.has-children]:after:w-[calc(2rem+1px)] [&.has-children]:after:h-px [&.has-children]:after:bg-neutral-200 [&.has-children]:after:-translate-y-1/2 [&.has-children]:after:z-[1] [&.has-children.active]:after:bg-primary-500 [&.is-child]:before:content-[''] [&.is-child]:before:absolute [&.is-child]:before:top-1/2 [&.is-child]:before:end-[calc(100%+0.5rem)] [&.is-child]:before:w-[calc(2rem+1px)] [&.is-child]:before:h-px [&.is-child]:before:bg-neutral-200 [&.is-child]:before:-translate-y-1/2 [&.is-child]:before:z-[1] [&.is-child.active]:before:bg-primary-500"
    [class.has-children]="node().count && node().isSelected"
    [class.border-neutral-200]="!node().isSelected"
    [class.border-primary-500]="node().isSelected || node().isHighlighted"
    [class.active]="active"
    [class.is-child]="node().isChild"
    [class.me-5xl]="node().count && active"
    [class.bg-neutral-50]="node().isHighlighted"
    [class.cursor-default]="!node().count"
    [class.ms-5xl]="node().isChild"
    (click)="node().count && onCardClick()">
    <ng-container [ngTemplateOutlet]="cardTemplate" />
  </button>
}

<!-- for card tooltip template -->
<ng-template #cardTemplate>
  <lib-avatar
    [img]="node().image?.url ?? ''"
    [fullName]="node().name"
    borderRadius="rounded-full"
    [size]="''"
    [imgDimensions]="{ width: 32, height: 32 }" />

  @if (!node().details) {
    @if (node().name) {
      <div
        class="text-neutral-900 text-sm font-semibold w-full"
        libTrimTooltip
        placement="top"
        [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top w-[19.875rem] text-balance'"
        [trimLength]="node().title ? 28 : 50"
        [fullText]="node().name"></div>
    }

    @if (node().title) {
      <div>{{ node().title }}</div>
    }
  } @else {
    <div class="flex flex-col gap-x-sm w-full">
      <div
        class="text-neutral-900 text-sm font-semibold truncate max-w-[12rem]">
        {{ node().name }}
      </div>

      @if (showTitle()) {
        <div class="text-neutral-700 text-xs2 font-medium">
          {{ node().title }}
        </div>
      }
    </div>
  }

  @if (node().count) {
    <lib-badge
      [label]="node().count.toString()"
      [badgeClass]="'bg-primary-50 text-primary-700 text-xs font-medium px-sm border-none'" />
  } @else if (node().viewRoute) {
    <a
      [routerLink]="node().viewRoute"
      (click)="$event.stopPropagation()"
      class="text-primary-600 flex items-center">
      <lib-view-icon iconClass="size-5 text-neutral-900" />
    </a>
  }
</ng-template>
